import { GET_MESSAGE, LIST_MESSAGE } from "../actions/types";

const initialState = {
  message: null,
  messages: {
    count: 0,
    rows: [],
  },
};

const messages = (state = initialState, action) => {
  switch (action.type) {
    case GET_MESSAGE:
      return {
        ...state,
        message: action.payload,
        messages: initialState.messages,
      };
    case LIST_MESSAGE:
      return {
        ...state,
        messages: action.payload,
        message: initialState.message,
      };
    default:
      return state;
  }
};

export default messages;
